// extracted by mini-css-extract-plugin
module.exports = {"title":"colTitle-module--title---HzAO"};